import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["setCompletedPlaylists", "shouldShowModalImmediately"],
  _excluded2 = ["mutateAsync"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMutation, useQueryClient } from '@tanstack/react-query';
import track, { getSessionToken } from 'utils/track';
import api from 'utils/api';
import { assetQueryKeys } from '.';
import { playlistQueryKeys } from 'actions/playlists';
export function useMarkMyAssetAsDone(_ref) {
  var setCompletedPlaylists = _ref.setCompletedPlaylists,
    shouldShowModalImmediately = _ref.shouldShowModalImmediately,
    options = _objectWithoutProperties(_ref, _excluded);
  var queryClient = useQueryClient();
  function markAssetAsDone(_x) {
    return _markAssetAsDone.apply(this, arguments);
  }
  function _markAssetAsDone() {
    _markAssetAsDone = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var id, playlistId;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            id = _ref2.id, playlistId = _ref2.playlistId;
            return _context.abrupt("return", api('put', "/api/me/assets/".concat(id, "/read"), {
              collection_id: playlistId,
              session_token: getSessionToken()
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _markAssetAsDone.apply(this, arguments);
  }
  var _useMutation = useMutation(_objectSpread(_objectSpread({
      mutationFn: markAssetAsDone
    }, options), {}, {
      onSuccess: function onSuccess(data, variables) {
        track('asset', 'read', variables === null || variables === void 0 ? void 0 : variables.id);
        return Promise.all([queryClient.invalidateQueries({
          queryKey: assetQueryKeys.singleAsset(variables === null || variables === void 0 ? void 0 : variables.id)
        }), queryClient.invalidateQueries({
          queryKey: playlistQueryKeys.allPlaylists
        })]).then(function () {
          setCompletedPlaylists({
            playlists: data.completedPlaylists,
            initialPlaylistId: variables === null || variables === void 0 ? void 0 : variables.playlistId,
            shouldShowModalImmediately: shouldShowModalImmediately
          });
        });
      }
    })),
    mutateAsync = _useMutation.mutateAsync,
    result = _objectWithoutProperties(_useMutation, _excluded2);
  return _objectSpread(_objectSpread({}, result), {}, {
    markMyAssetAsDone: mutateAsync
  });
}
export default useMarkMyAssetAsDone;